<template>
  <span class="flex justify-between w-full items-center">
    <p class="heading-xs">+ lägg till</p>
    <span class="flex flex-col md:items-end ml-auto">
      <p
        v-if="
          familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee
        "
        class="heading-xxs text-text-success"
      >
        Prissänkning
      </p>
      <span class="flex gap-8">
        <p
          v-if="
            familyStore.selectedFamilyPlanBundlePrice &&
            familyStore.selectedFamilyPlanBundlePrice.Plan?.RegularMonthlyFee
          "
          class="heading-xxs text-text-secondary strike-through"
          aria-hidden="true"
        >
          {{
            familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee
          }}
        </p>
        <span class="sr-only">
          {{
            `Tidigare ${familyStore.selectedFamilyPlanBundlePrice?.Plan?.RegularMonthlyFee} kronor i månaden, nu `
          }}
        </span>
        <p class="heading-xxs" aria-hidden="true">
          {{ familyStore.selectedFamilyPlanBundlePrice?.Plan?.MonthlyFee }}
          kr/mån
        </p>
        <span class="sr-only"
          >{{
            familyStore.selectedFamilyPlanBundlePrice?.Plan?.MonthlyFee
          }}
          kronor i månaden</span
        >
      </span>
    </span>
  </span>
</template>
<script lang="ts" setup>
const familyStore = useFamilyStore();
</script>
